import { render, staticRenderFns } from "./inAassessment.vue?vue&type=template&id=d84b654e&scoped=true&"
import script from "./inAassessment.vue?vue&type=script&lang=js&"
export * from "./inAassessment.vue?vue&type=script&lang=js&"
import style0 from "./inAassessment.vue?vue&type=style&index=0&id=d84b654e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84b654e",
  null
  
)

export default component.exports